// 模板 1：当前默认官网风格（原首页 + newsTemplate0 + softwareTemplate0）

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '为企业数字化转型赋能',
        content:
          '结合行业最佳实践，打造符合企业特色的数字化解决方案，推动业务创新升级。'
      },
      {
        img: require('@/assets/img/banner_2.jpg'),
        path: '',
        title: '一站式技术服务保障',
        content:
          '从项目启动到系统上线，全程提供专业技术支持，确保项目顺利交付。'
      },
      {
        img: require('@/assets/img/banner1.png'),
        path: '',
        title: '量身定制的系统方案',
        content:
          '深入了解企业需求，设计符合业务特点的系统架构，实现精准匹配。'
      },
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '专业团队全程护航',
        content:
          '经验丰富的技术团队，提供 7×24 小时服务支持，保障系统稳定运行。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '智能数据分析平台',
      subtitle: '/ Intelligent Data Analytics Platform',
      paragraphs: [
        '面对日益增长的数据量和复杂的业务场景，企业需要一个能够快速处理、深度分析数据的智能平台。我们的数据分析平台集成了数据采集、存储、计算、分析、展示等全流程能力，帮助企业从海量数据中挖掘价值。',
        '平台采用先进的大数据处理技术，支持实时和离线两种计算模式，能够处理 TB 级甚至 PB 级的数据规模。内置丰富的分析算法和模型，支持多维分析、趋势预测、异常检测等高级功能，通过直观的可视化界面，让数据洞察变得简单易懂。'
      ],
      buttonText: '免费试用'
    },
    contact: {
      title: '值得信赖的技术合作伙伴',
      subTitle: '用心服务每一位客户，用技术成就每一个项目',
      buttonText: '联系我们'
    },
    customers: [
      {
        logo: require('@/assets/img/logo_hp.png'),
        title: '医疗健康机构 · 信息中心主任',
        content:
          '我们机构需要管理患者信息、预约挂号、药品库存等多个业务模块，之前系统分散，数据不互通。新系统整合了所有业务，医生可以快速查看患者历史记录，药房能实时掌握库存情况，整体工作效率提升明显，患者满意度也大幅提高。'
      },
      {
        logo: require('@/assets/img/logo_toyota.png'),
        title: '餐饮连锁企业 · 运营总监',
        content:
          '门店分布广，需要统一管理菜品、库存、订单和会员信息。系统上线后，总部可以实时监控各门店经营数据，统一制定营销策略，会员积分和优惠券也能跨店使用，顾客体验更好，我们的营业额也有了显著增长。'
      },
      {
        logo: require('@/assets/img/logo_kk.png'),
        title: '物业管理公司 · 总经理',
        content:
          '管理多个小区，涉及收费、报修、停车、安防等多个方面，之前管理混乱。现在通过统一平台，业主可以在线缴费、报修，物业人员能及时处理工单，各项数据一目了然，管理效率大幅提升，业主投诉明显减少。'
      }
    ],
    advantages: [
      {
        icon: require('@/assets/img/logo_white.png'),
        title: '丰富的行业经验',
        html: '<p>服务过众多行业客户</p>积累了大量实战案例，能快速理解业务需求'
      },
      {
        icon: require('@/assets/img/computer.png'),
        title: '先进的技术架构',
        html: '<p>采用主流技术框架</p>确保系统性能稳定，便于后续维护和升级'
      },
      {
        icon: require('@/assets/img/qiniu.png'),
        title: '严格的质量管控',
        html: '<p>建立完善的质量体系</p>从需求到交付全程把控，确保项目质量'
      },
      {
        icon: require('@/assets/img/tel.png'),
        title: '贴心的服务态度',
        html: '<p>以客户满意为目标</p>主动沟通，及时反馈，提供优质服务体验'
      }
    ]
  },
  company: {
    name: '风行网络科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__是一家专业从事企业信息化建设的科技公司，拥有一支技术精湛、经验丰富的开发团队。公司自成立以来，始终专注于为企业提供高质量的信息化解决方案，帮助客户通过技术创新实现业务转型和效率提升。',
      '我们的服务范围包括企业管理系统、电商平台、移动应用、数据分析平台等多个方向，已为众多企业提供了专业的信息化服务。在项目实施过程中，我们注重与客户的深度沟通，确保系统真正符合业务需求。我们相信，只有真正理解客户需求，才能提供有价值的解决方案。未来，我们将继续秉承专业、诚信、创新的理念，为客户提供更优质的服务。'
    ]
  },
  news: [
    {
      id: '008',
      title: '公司完成新一轮战略融资',
      introduce:
        '公司顺利完成新一轮战略融资，本轮融资将主要用于技术研发、团队建设和市场拓展。投资方对公司的发展前景和技术实力给予了高度认可，这将为公司未来的快速发展提供有力支撑。',
      date: '10-12',
      year: '2024'
    },
    {
      id: '007',
      title: '成功签约多个重点客户项目',
      introduce:
        '近期公司成功签约多个重点客户的信息化建设项目，涉及金融、医疗、制造等多个行业领域。这些项目的签约进一步巩固了公司在行业内的市场地位，也体现了客户对公司技术实力和服务能力的认可。',
      date: '07-28',
      year: '2024'
    },
    {
      id: '006',
      title: '通过 ISO 质量管理体系认证',
      introduce:
        '公司顺利通过 ISO9001 质量管理体系认证，这标志着公司的质量管理水平达到了国际标准。通过建立完善的质量管理体系，公司将进一步提升项目交付质量，为客户提供更加可靠的服务保障。',
      date: '04-15',
      year: '2024'
    },
    {
      id: '005',
      title: '成立用户体验研究中心',
      introduce:
        '公司正式成立用户体验研究中心，专注于产品可用性与交互设计优化，并将研究成果持续应用到各条产品线上，以提升整体用户满意度。',
      date: '01-08',
      year: '2024'
    },
    {
      id: '004',
      title: '年度客户成功案例集发布',
      introduce:
        '公司整理过去一年与重点客户的合作实践，编撰成《年度客户成功案例集》，涵盖多个行业的数字化转型路径，为后续项目提供可参考的落地经验。',
      date: '11-18',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '智能小镇管理系统 · 应用场景',
      sections: [
        {
          heading: '1. 统一管理平台',
          content:
            '系统将小镇的各项管理业务整合到一个统一的平台上，包括人员管理、设施管理、环境监测、安全监控等各个方面。通过数据大屏，管理者可以一目了然地掌握小镇的整体运行情况，包括各项指标的状态、异常事件的分布、处理进度等信息。系统还支持移动端访问，管理者可以随时随地查看和处理各类事务。'
        },
        {
          heading: '2. 居民服务窗口',
          content:
            '为小镇居民提供便捷的线上服务入口，居民可以通过手机或电脑办理各类业务，包括水电费缴纳、物业费支付、证件申请、信息查询等。系统建立了完善的工单流转机制，居民提交的各类诉求会自动流转到相应的处理部门，处理进度实时可查。系统还支持在线评价功能，居民可以对服务质量进行评价，促进服务质量的持续改进。'
        },
        {
          heading: '3. 产业促进工具',
          content:
            '系统为小镇的产业发展提供数据支撑和服务工具。通过收集和分析入驻企业的各类数据，系统可以帮助管理方了解产业发展状况，识别优势产业和潜力企业。系统还提供政策发布、项目申报、企业服务等功能，帮助企业更好地了解政策、申请支持、解决问题，促进产业健康发展。'
        },
        {
          heading: '4. 分步实施路径',
          content:
            '考虑到小镇管理的复杂性和预算限制，我们采用分步实施的建设策略。首先建设最核心、最紧迫的功能模块，让系统尽快上线并发挥作用。然后根据使用反馈和业务发展需要，逐步增加新的功能模块，不断完善系统能力。这种渐进式的建设方式，既能快速见效，又能控制成本，还能根据实际情况灵活调整，确保系统建设符合实际需求。'
        }
      ]
    },
    bigData: {
      title: '大数据管理系统 · 功能说明',
      sections: [
        {
          heading: '1. 解决企业数据管理难题',
          desc:
            '随着企业业务规模的扩大，数据量呈指数级增长，如何有效管理和利用这些数据成为企业面临的重要挑战。我们的系统专门针对这一痛点设计，帮助企业建立统一的数据管理体系，打破数据壁垒，实现数据的集中管理和高效利用。'
        },
        {
          heading: '2. 强大的数据处理能力',
          desc:
            '系统集成了先进的数据处理技术，能够快速处理各种类型和格式的数据。支持实时数据流处理和批量数据处理两种模式，满足不同场景的需求。内置智能数据清洗算法，自动识别和修复数据质量问题，确保数据的准确性和完整性。同时提供灵活的数据转换和聚合功能，满足各种分析需求。'
        },
        {
          heading: '3. 灵活的系统架构',
          desc:
            '系统采用微服务架构设计，各功能模块相对独立，可以根据实际需求灵活组合和扩展。支持分布式部署，可以轻松应对数据量增长带来的性能压力。系统具备良好的兼容性，可以与现有的各种业务系统无缝对接，保护企业现有投资。同时支持多种部署模式，满足不同企业的安全和管理要求。'
        },
        {
          heading: '4. 直观的数据展示',
          desc:
            '系统提供丰富的数据可视化功能，支持多种图表类型和展示方式，让复杂的数据变得直观易懂。用户可以通过拖拽的方式快速创建个性化的数据看板，无需编程知识即可完成数据分析。系统还支持数据钻取和多维度分析，帮助用户深入挖掘数据价值，发现业务规律和趋势。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '业务系统定制',
      engTitle: 'Custom Business System',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-2',
      title: '云端部署与运维',
      engTitle: 'Cloud Deployment & Ops',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-3',
      title: '电商平台开发',
      engTitle: 'E-commerce Development',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-4',
      title: '移动应用开发',
      engTitle: 'Mobile Application',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '全栈开发工程师',
    responsibilities: [
      '参与公司各类软件项目的全栈开发，负责前后端功能的实现和优化；',
      '根据产品需求进行技术方案设计，编写高质量代码，确保系统稳定运行；',
      '参与代码评审和技术分享，持续提升团队整体技术水平，协助解决项目中的技术难题。'
    ],
    requirements: [
      '熟练掌握前端技术（HTML/CSS/JavaScript/Vue/React 等）和后端技术（Java/Python/Node.js 等）；',
      '熟悉数据库设计和 SQL 优化，了解常用框架和工具的使用；',
      '具备良好的学习能力和沟通能力，能够快速适应新技术，有责任心和团队合作精神。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-1.js